import * as XLSX from 'xlsx'
import { Task } from '../lib/types/database.types'
import { getTaskCurrentStatusDueDate } from './statusDates'

const toDisplayDate = (value: string | null) => value || ''

export const exportTasksToExcel = (
  tasks: Task[],
  assigneeLabelMap: Map<string, string>,
  fileName: string
) => {
  const rows = tasks.map((task) => ({
    Title: task.title,
    Status: task.status,
    Type: task.type,
    'Dev Priority': task.priority,
    'Sales Priority': task.client_priority,
    Weight: task.weight ?? '',
    App: task.related_app,
    'Requested By': task.requested_by,
    'Support Ticket No': task.support_ticket_no || '',
    'Assigned To': task.assigned_to ? assigneeLabelMap.get(task.assigned_to) || 'Unknown user' : 'Unassigned',
    'Current Status Due Date': toDisplayDate(getTaskCurrentStatusDueDate(task)),
    'Overall Due Date': toDisplayDate(task.overall_due_date),
    'Estimated Hours': task.estimated_hours ?? '',
    Billable: task.billable ? 'Yes' : 'No',
    'Release Version': task.release_version || '',
    'Release Date': toDisplayDate(task.release_date),
    'Created At': task.created_at,
    'Updated At': task.updated_at,
  }))

  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.json_to_sheet(rows)
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Tasks')
  XLSX.writeFile(workbook, fileName)
}
